import { inject, DOCUMENT } from '@angular/core';

import { Actions, ROOT_EFFECTS_INIT, createEffect, ofType } from '@ngrx/effects';
import { concatLatestFrom } from '@ngrx/operators';
import { Store } from '@ngrx/store';
import { tap } from 'rxjs/operators';

import { LOCAL_STORAGE } from '@app/core/injection-tokens';
import { UserPreferences } from './user-preferences.model';
import { THEME_STORAGE_KEY, UserPreferencesFeature } from './user-preferences.feature';
import { UserPreferencesActions } from './user-preferences.actions';

export const setAndStoreTheme = createEffect(
  (actions$ = inject(Actions), store = inject(Store<UserPreferences>), document = inject(DOCUMENT), localStorage = inject(LOCAL_STORAGE)) =>
    actions$.pipe(
      ofType(ROOT_EFFECTS_INIT, UserPreferencesActions.toggleThemePreference),
      concatLatestFrom(() => store.select(UserPreferencesFeature.selectTheme)),
      tap(([, theme]) => {
        document.body.setAttribute('data-theme', theme);
        localStorage.setItem(THEME_STORAGE_KEY, theme);
      })
    ),
  { functional: true, dispatch: false }
);
